module.exports = __webpack_public_path__ + "media/images/sp/stores/hamamatsu/store-hamamatsu-opening-f6ae6caff146b4007323bcbfc347f8b2.webp";